import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useHistory, useRouteMatch } from "react-router-dom";
import { Tabs, Tag } from "antd";
import { IoArrowBack } from "react-icons/io5";
import { RiArrowRightSLine } from "react-icons/ri";
import { dashboardRoute, AppConstants } from "../../../constants";
import { TableContainer, InputGroup } from "../../../UI";
import { useSelector, useDispatch } from "react-redux";
import { getTrainerSubscribedUsers, getAllTrainers } from "../../../redux/actions";
import Container from "./style";
import { columns } from "./tableData";

const TrainerProfile = () => {
  const history = useHistory();
  const { params } = useRouteMatch();
  const trainerId = params[dashboardRoute.admin.trainerProfile.params];
  const [subscribeTrainerUsers, setSubscribeTrainerUsers] = useState(null);
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });
  const dispatch = useDispatch();
  const { gymLocations, trainers } = useSelector((s) => s.dashStats);
  const trainer = Array.isArray(trainers?.data)
    ? trainers.data.find((t) => t.id === Number(trainerId))
    : null;

  const handleQueryFetch = useCallback(
    ({ page, start_date, end_date } = {}) => {
      let queries = [];

      const currentStartDate =
        start_date !== undefined ? start_date : filters.start_date;
      const currentEndDate =
        end_date !== undefined ? end_date : filters.end_date;

      if (page) {
        queries.push(`page=${page}`);
      }

      if (currentStartDate) {
        queries.push(`start_date=${currentStartDate}`);
      }

      if (currentEndDate) {
        queries.push(`end_date=${currentEndDate}`);
      }

      setSubscribeTrainerUsers(null);
      getTrainerSubscribedUsers(
        trainerId,
        queries.length > 0 ? `?${queries.join("&")}` : ""
      ).then((res) => {
        if (res?.status === "success") {
          setSubscribeTrainerUsers(res.data);
        }
      });
    },
    [trainerId, filters]
  );

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (!trainer) {
      dispatch(getAllTrainers());
    }
  }, [trainer, dispatch]);

  useEffect(() => {
    if (trainerId) {
      handleQueryFetch();
    }
  }, [trainerId, filters.start_date, filters.end_date, handleQueryFetch]);

  // const handleQueryFetch = ({ page, search } = {}) => {
  //   let queries = [];

  //   if (page) {
  //     queries.push(`page=${page}`);
  //   }

  //   if (search) {
  //     queries.push(`inventory_name=${search}`);
  //   }

  //   setSubscribeTrainerUsers(null);
  //   getUserPurshaseHistory(
  //     trainerId,
  //     queries.length > 0 ? `?${queries.join("&")}` : null
  //   ).then((res) => {
  //     setSubscribeTrainerUsers(res);
  //   });
  // };

  // useEffect(() => {
  //   if (trainerId && prevId.current !== trainerId) {
  //     dispatch(altLoadingState(true));
  //     if (trainerId) {
  //       searchUsers(trainerId).then((response) => {
  //         setActiveUser(response.data);
  //         dispatch(altLoadingState(false));
  //       });
  //     } else {
  //       prevId.current = trainerId;
  //       getUser(trainerId).then((response) => {
  //         dispatch(altLoadingState(false));
  //         if (response) {
  //           setActiveUser(response.data);
  //         } else {
  //           setActiveUser("");
  //         }
  //       });
  //     }
  //   }
  // }, [params, prevId, dispatch, trainerId]);

  return (
    <>
      <Container>
        <header>
          <div className="header-row">
            <button
              type="button"
              aria-label="back"
              onClick={() => {
                history.goBack();
              }}
            >
              <IoArrowBack />
            </button>
            <h1 className="u-typo-title">Trainer Profile Page</h1>
          </div>
          <nav>
            <NavLink to={dashboardRoute.admin.trainer}>Manage Trainer</NavLink>
            <RiArrowRightSLine />
            <NavLink
              to={`${dashboardRoute.admin.trainerProfile.link}/${
                params[dashboardRoute.admin.trainerProfile.params]
              }`}
            >
              Trainer Profile Page
            </NavLink>
          </nav>
        </header>

        {trainer && (
          <div className="profile-grid">
             <div className="profile-card">
                <div className="trainer-photo" style={{
                  backgroundImage: trainer.trainer_details?.image_data ? `url(${AppConstants.imgBase}${trainer.trainer_details.image_data})` : 'none',
                  backgroundColor: '#eee',
                  width: '120px',
                  height: '120px',
                  borderRadius: '50%',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  marginBottom: '1em'
                }} />
                <h2 className="trainer-name">{trainer.trainer_details?.name}</h2>
                <p className="trainer-specialization" style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', justifyContent: 'center' }}>
                  {(trainer.trainer_details?.specialization || 'General Fitness').split(',').map((tag, i) => (
                    <Tag color="green" key={i}>{tag.trim()}</Tag>
                  ))}
                </p>
                <div className="trainer-meta">
                   <p><strong>Fee:</strong> ₦{trainer.trainer_fee}</p>
                   <p><strong>Gender:</strong> {trainer.trainer_details?.gender === 'm' ? 'Male' : 'Female'}</p>
                   <p><strong>Location:</strong> {gymLocations[trainer.location_id]}</p>
                   {trainer.trainer_details?.experience && <p><strong>Experience:</strong> {trainer.trainer_details.experience} Years</p>}
                </div>
             </div>
             <div className="profile-details">
                <div className="detail-section">
                   <h3>About</h3>
                   <p>{trainer.trainer_details?.bio || 'No bio provided.'}</p>
                </div>
                {trainer.trainer_details?.certifications && (
                  <div className="detail-section">
                     <h3>Certifications</h3>
                     <p>{trainer.trainer_details.certifications}</p>
                  </div>
                )}
             </div>
          </div>
        )}

        <div className="filters-row">
           <InputGroup 
              type="date"
              label="Start Date"
              name="start_date"
              value={filters.start_date}
              onChange={handleFilterChange}
           />
           <InputGroup 
              type="date"
              label="End Date"
              name="end_date"
              value={filters.end_date}
              onChange={handleFilterChange}
           />
        </div>

        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="Subscribed Users" key="1">
            <TableContainer
              {...{
                hasSearch: false,
                columns: columns({
                  gymLocations,
                }),
                searchHandler: (searchVal) => {
                  // handleQueryFetch({ search: searchVal });
                },

                dataSource: subscribeTrainerUsers?.data,
                rowKey: "id",
                loading: !subscribeTrainerUsers?.data,
                pagination: {
                  pageSize: subscribeTrainerUsers?.per_page,
                  current: subscribeTrainerUsers?.current_page,
                  total: subscribeTrainerUsers?.total,
                  onChange: (page) => {
                    handleQueryFetch({ page });
                  },
                },
              }}
            />
          </Tabs.TabPane>
        </Tabs>
      </Container>
    </>
  );
};

export default TrainerProfile;
